<template>
	<div id="footer">
		<div class="footer-box-1 flex-center">
			<div class="container-1 flex-between">
				<div class="container-1-left"></div>
				<div class="container-1-right flex-between">
					<div class="container-1-right-div">
						<p class="container-1-right-div-p-1">资源保证</p>
						<p class="container-1-right-div-p-2">优质可靠的资源保证</p>
					</div>
					<div class="container-1-right-xian"></div>
					<div class="container-1-right-div">
						<p class="container-1-right-div-p-1">交易保障</p>
						<p class="container-1-right-div-p-2">全方位的安全保证</p>
					</div>
					<div class="container-1-right-xian"></div>
					<div class="container-1-right-div">
						<p class="container-1-right-div-p-1">公开透明</p>
						<p class="container-1-right-div-p-2">标准流程 公平公正</p>
					</div>
					<div class="container-1-right-xian"></div>
					<div class="container-1-right-div">
						<p class="container-1-right-div-p-1">精准匹配</p>
						<p class="container-1-right-div-p-2">海量资源多种类目</p>
					</div>
				</div>
			</div>
		</div>

		<div class="footer-box-2 flex-between">
			<div class="footer-box-2-left ">
				<dl>
					<dt>快速导航</dt>
					<dd><a @click.prevent="go('/corpore')">竞价处置</a></dd>
					<dd><a @click.prevent="go('/pricing')">金属行情</a></dd>
					<dd><a @click.prevent="go('/enterprise')">企业专场</a></dd>
				</dl>
				<dl>
					<dt>帮助中心</dt>
					<div style="display: flex;">
						<div>
							<dd  @click="classify(104)">竞拍流程</dd>
							<dd  @click="classify(104)">出价流程</dd>
							<dd  @click="classify(92)">成交规则</dd>
							<dd  @click="classify(92)">保证金规则</dd>
						</div>
						<div style="margin-left: 40px;">
							<dd  @click="classify(104)">注册认证</dd>
							<dd  @click="classify(104)">拍前准备</dd>
							<dd  @click="classify(92)">缴纳保证金</dd>
							<dd  @click="classify(104)">出价竞拍</dd>
						</div>
					</div>
				</dl>
				<dl>
					<dt></dt>

				</dl>
				<dl>
					<dt>联系我们</dt>
					<dd>
						<span>客服热线：</span>
						<span>{{site.costomer_mobile}}</span>
					</dd>
					<dd>
						<span>客服QQ：</span>
						<span>{{site.qq_num}}</span>
					</dd>
					<dd>
						<span>邮箱：</span>
						<span>{{site.email}}</span>
					</dd>
					<dd>
						<span>地址：</span>
						<span>{{site.address}}</span>
					</dd>
				</dl>
			</div>
			<div class="footer-box-2-right">
				<img src="../assets/erweima.png" alt="" />
				<p>官方公众号</p>
			</div>
		</div>

		<div class="footer-box-3">
			<!-- <span>河北中锆拍卖有限公司</span> -->
			
			<a href="https://beian.miit.gov.cn/https:/beian.miit.gov.cn/#/Integrated/index" target="_blank">{{site.site_beian}}</a>
			<span>{{site.site_copyright}}</span>
			<a href="https://beian.mps.gov.cn/#/query/webSearch?code=13010402003477" target="_blank">冀公网安备13010402003477号</a>
		</div>
	</div>
</template>

<script>
	import {
		getSiteConfig
	} from '@/api/home/index.js';
	export default {
		data () {
			return {
				site:{}
			}
		},
		created() {
			this.getSite();
		},
		methods:{
			classify(classifyId) {
			
				const url = `/helpCenter?classifyId=${classifyId}`
				window.open(url, '_blank')
			},
			async getSite() {
				try{
					let res = await getSiteConfig();
					// console.log(res)
					if (res.code === 1) {
						this.site = res.data.site;
					}
				} catch (err) {
					
				} finally {
					
				}
			},
			go(url) {
				this.$router.push(url)
			}
		}
	}
</script>

<style scoped lang="scss">
	#footer {
		min-width: 1200px;
		height: 483px;
		background-color: #E8E8E8;
		overflow: hidden;

		.footer-box-1 {
			width: 100%;
			height: 122px;
			border-bottom: 1px solid #D7D7D7;

			.container-1 {
				width: 1400px;
				height: 80px;

				.container-1-left {
					width: 202px;
					height: 60px;
					background-image: url('../assets/logo1.png');

					img {
						width: 100%;
						height: 100%;
					}
				}

				.container-1-right {
					// .container-1-right-div:not(:first-child) {
					// 	margin-left: 39px;

					// }
					.container-1-right-div {
						.container-1-right-div-p-1 {
							font-weight: 500;
							font-size: 18px;
							color: #0E71BC;
						}

						.container-1-right-div-p-2 {
							font-weight: 400;
							font-size: 14px;
							color: #666666;
						}
					}


					.container-1-right-xian {
						width: 0px;
						height: 31px;
						border-radius: 0px 0px 0px 0px;
						border: 1px solid #D2D2D2;
						margin-left: 39px;
						margin-right: 39px;
					}
				}



			}
		}

		.footer-box-2 {
			width: 1400px;
			height: 292px;
			margin: 0 auto;

			.footer-box-2-left {
				display: flex;

				// 核心dl样式
				dl {

					// 第一个dl无边距，其他左侧529px
					&:not(:first-child) {
						margin-left: 154px;
					}

					dt {
						font-size: 18px;
						color: #333333;
						font-weight: 500;
						margin-bottom: 6px;


					}

					dd {
						cursor: pointer;
						font-weight: 400;
						font-size: 14px;
						color: #666666;
						margin-top: 18px;

						&:hover {
							color: $color-font;
						}
					}



				}
			}


			.footer-box-2-right {
				width: 140px;
				height: 181px;

				img {
					width: 140px;
					height: 140px;
				}

				p {
					text-align: center;
					margin-top: 10px;
					color: #666666;
					font-size: 14px;
				}
			}

		}

		.footer-box-3 {
			width: 100%;
			height: 69px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top: 1px solid #D7D7D7;
			font-weight: 400;
			font-size: 14px;
			color: #666666;
			span{
				&:not(:first-child) {
					margin-left: 15px;
				}
			}
			
		}
	}
</style>